import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getGames, deleteGame } from './actions';
import { selectGames } from './selectors';
import { selectCurrentUser } from '../Login/selectors';
import CreateGame from './CreateGame';
import PushSettings from '../Push/PushSettings';
import ConfirmButton from '../ConfirmButton';
import { Muted } from '../Controls';
import { Page, PageTitle, Panel, PanelTitle } from '../Page';
import { gameSummary } from './gameSummary';
import { GameList, GameRow, Status } from './styled';

const Games = () => {
  const dispatch = useDispatch();
  const games = useSelector(selectGames);
  const currentUser = useSelector(selectCurrentUser);
  const userId = currentUser && currentUser.get('id');

  useEffect(() => {
    dispatch(getGames());
  }, [dispatch]);

  return (
    <Page>
      <PageTitle>Games</PageTitle>
      <Panel>
        <PanelTitle>New game</PanelTitle>
        <CreateGame />
      </Panel>
      <PushSettings />
      <Panel>
        <PanelTitle>Your games</PanelTitle>
        {!games.size && <Muted>No games yet.</Muted>}
        <GameList>
          {games.map((game) => {
            const summary = gameSummary(game, userId);
            return (
              <GameRow key={game.get('id')}>
                <Link to={`/games/${game.get('id')}`}>
                  <strong>{summary.against}</strong>
                  <Status $yourMove={summary.yourMove}>{summary.status}</Status>
                </Link>
                <ConfirmButton
                  onConfirm={() => dispatch(deleteGame(game.get('id')))}
                  prompt={`Delete the game ${summary.against}?`}
                  confirmLabel="Delete"
                >
                  Delete
                </ConfirmButton>
              </GameRow>
            );
          })}
        </GameList>
      </Panel>
    </Page>
  );
};

export default Games;
